import { Button, Loading, TextInput } from "@alm/flow-ds/components";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
	name?: string;
	setName: Dispatch<SetStateAction<string>>;
	alert: boolean;
	onUpdateRole?: (data: { name?: string }) => void;
	loading?: boolean;
	systemRole?: boolean;
}

export default ({
	name,
	setName,
	alert,
	onUpdateRole,
	loading,
	systemRole,
}: Props) => {
	const { t } = useTranslation();

	return (
		<div className="admin__role-form__name">
			<TextInput
				className="admin__role-form__name-input"
				label={t("main.admin.labels.roleName")}
				required={true}
				onChange={e => setName(e.target.value)}
				value={name}
				status={alert && !name?.trim() ? "error" : undefined}
				disabled={systemRole}
				hint={t("main.admin.text.roleNameHint")}
			/>
			{onUpdateRole && (
				<Button
					label={!loading && t("main.admin.labels.rename")}
					className="btn-tertiary admin__role-form__name-btn"
					onClick={() => onUpdateRole({ name })}
					disabled={!name?.trim() || systemRole}>
					{loading && <Loading />}
				</Button>
			)}
		</div>
	);
};
